import templateBase from './templates/products-page-toolbox-base.view.html';
import template_t1 from './templates/products-page-toolbox-t1.view.html';
import template_t2 from './templates/products-page-toolbox-t2.view.html';
import template_t11 from './templates/products-page-toolbox-t11.view.html';
import template_t15 from './templates/products-page-toolbox-t15.view.html';
import templateAD from './templates/products-page-toolbox.view-adaptative.html';

function MenuDirective(SessionService) {

    let response = SessionService.get('components');
    let htmlTemplate = templateBase;
    if (__env.adaptative){
      htmlTemplate = templateAD;
    }else{
      if(response.PRODUCT_PAGE_TOOLBOX.component == 'template_t1'){ htmlTemplate = template_t1; }
      else if(response.PRODUCT_PAGE_TOOLBOX.component == 'template_t2'){ htmlTemplate = template_t2; }
      else if(response.PRODUCT_PAGE_TOOLBOX.component == 'template_t11'){ htmlTemplate = template_t11; }
      else if(response.PRODUCT_PAGE_TOOLBOX.component == 'template_t15'){ htmlTemplate = template_t15; }
    }
    return {
        restrict: 'E',
        template: htmlTemplate
    };
}

MenuDirective.$inject = ['SessionService'];

export default MenuDirective;


// WEBPACK FOOTER //
// ./www/components/catalog/products-list/products-page-toolbox/products-page-toolbox.directive.js